export default __webpack_public_path__ + "static/media/percentage.0a6f7679.svg";